import React, { useState, useEffect, useRef } from "react";
import classNames from "classnames";
import { RichText } from "@sitecore-jss/sitecore-jss-react";
import { getOverallSettingsClasses, componentId, mobileIs } from "../../utils/siteUtils";
import { BackgroundImage, PrimaryButton } from "../../elements";
import "./style.scss";
import { gtag } from "../../utils";
const TextBlock = props => {
    const { rendering, fields, page } = props;
    const {
        pc_title, pc_subtitle, m_title, m_subtitle, pc_image, m_image
    } = fields;
    const isMobile = mobileIs()

    useEffect(() => {

    }, []);
    const rootClasses = classNames("c-text-block", getOverallSettingsClasses(fields));
    const rootId = componentId(rendering);
    return (
        <div className={rootClasses} datasourceid={rendering.dataSource} id={rootId}>
            <div className="c-text-block-images">
                {!isMobile && <img src={pc_image?.value?.src} />}
                {isMobile && <img src={m_image?.value?.src} />}
            </div>
            <div className={["c-text-block-content", (pc_image?.value?.src || m_image?.value?.src) ? 'hidden' : 'show'].join(' ')} >
                {!isMobile && <RichText tag="div" className="title" field={pc_title} />}
                {isMobile && <RichText tag="div" className="title" field={m_title} />}
                {!isMobile && <RichText tag="div" className="subtitle" field={pc_subtitle} />}
                {isMobile && <RichText tag="div" className="subtitle" field={m_subtitle} />}
            </div>
        </div>
    );
};

export default TextBlock;